<template lang="pug">
.input
  v-menu(
    v-for="(answer, key) in answer_values"
    v-model="menu"
    ref="menu"
    min-width="290px"
    offset-y
    transition="scale-transition"
    :key="key"
    :close-on-content-click="false"
  )
    template(v-slot:activator="{ on, attrs }")
      v-text-field(
        v-on="on"
        v-bind="attrs"
        v-model="input"
        prepend-icon="mdi-calendar-month"
        readonly
        hide-details
        :label="answer.label"
      )
    v-date-picker(
      v-model="input"
      no-title
      scrollable
    )
      v-spacer
      v-btn(
        text
        color="primary"
        @click="menu = false"
      ) Cancel
      v-btn(
        text
        color="primary"
      ) OK
</template>
<script>
export default {
  name: 'Input',
  props: ['answer_values', 'value'],
  data() {
    return {
      menu: false
    }
  },
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.menu = false
      }
    }
  },
  methods: {
    saveDate(date) {
      this.$refs.menu.save(date)
      this.menu = false
    }
  }
}
</script>